import type { RouteRecordRaw } from 'vue-router';

import { COLLECT_ACCESS_SECTION } from '@/shared/inswitch/constants/collectAccess.constant';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const PaymentLinksPage = () => import('../pages/PaymentLinksPage/index.vue');

export const paymentLinksRoutes: Array<RouteRecordRaw> = [
  {
    path: '/payment-links',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'payment-links',
        component: PaymentLinksPage,
        meta: {
          requiresAuth: true,
          title: 'Link de cobro',
          accessRol: {
            section: COLLECT_ACCESS_SECTION,
            actions: ['VIEW'],
          },
        },
      },
    ],
  },
];
